var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import { stringify } from 'query-string';
import { getImageUrl } from '@shared/utils/images';
import { Wrapper, InnerWrapper, Name, StyledLink, IconWrapper, Shortcut, Image, } from './styles';
var DepartmentListItem = /** @class */ (function (_super) {
    __extends(DepartmentListItem, _super);
    function DepartmentListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DepartmentListItem.prototype.generateLink = function () {
        var _a = this.props, params = _a.params, session = _a.session, department = _a.department;
        var basePath = "/" + session.uuid + "/inspiration";
        var newParams = __assign({}, params);
        newParams.department = department.id;
        return basePath + "?" + stringify(newParams, { arrayFormat: 'bracket' });
    };
    DepartmentListItem.prototype.render = function () {
        var _a = this.props, active = _a.active, department = _a.department;
        var target = this.generateLink();
        return (_jsx(Wrapper, __assign({ active: active }, { children: _jsx(StyledLink, __assign({ to: target }, { children: _jsxs(InnerWrapper, __assign({ active: active }, { children: [_jsx(IconWrapper, { children: department.image ? (_jsx(Image, { src: getImageUrl(department.image), alt: department.name }, void 0)) : (_jsx(Shortcut, { children: department.name.charAt(0) }, void 0)) }, void 0), _jsx(Name, { children: department.name }, void 0)] }), void 0) }), void 0) }), void 0));
    };
    return DepartmentListItem;
}(Component));
export default DepartmentListItem;
